export interface IErrorProperty {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any | any[] | null;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errorParams: any | null; // additional info about error, e.g. id of entity that failed
}

export enum ELoadingEntity {
  PORTFOLIO_OVERVIEW_LIST = 'PORTFOLIO_OVERVIEW_LIST',
  PORTFOLIO_LIST = 'PORTFOLIO_LIST',
  ALL_INVESTMENTS = 'ALL_INVESTMENTS',
  PORTFOLIO_SINGLE = 'PORTFOLIO_SINGLE',
  CREATE_NEW_PORTFOLIO = 'CREATE_NEW_PORTFOLIO',
  CREATE_NEW_STRATEGY = 'CREATE_NEW_STRATEGY',
  UPDATE_PORTFOLIO = 'UPDATE_PORTFOLIO',
  UPDATE_STRATEGY = 'UPDATE_STRATEGY',
  UPDATE_EFEKTIKA_STRATEGY = 'UPDATE_EFEKTIKA_STRATEGY',
  DASHBOARD_BUSINESS_DAYS = 'DASHBOARD_BUSINESS_DAYS',
  PAGE_FAQS = 'PAGE_FAQS',
  FAQ_CATEGORIES = 'FAQ_CATEGORIES',
  FAQ_CATEGORY_DETAIL = 'FAQ_CATEGORY_DETAIL',
  FAQ_SEARCH = 'FAQ_SEARCH',
  DASHBOARD_SUMMARY = 'DASHBOARD_SUMMARY',
  CURRENT_USER = 'CURRENT_USER',
  AUTH_TOKEN_DATA = 'AUTH_TOKEN_DATA',
  AUTH_LOGOUT_ID_TOKEN = 'AUTH_LOGOUT_ID_TOKEN',
  HOTLINE_AVAILABILITY = 'HOTLINE_AVAILABILITY',
  SELECTED_PORTFOLIO_DETAIL = 'SELECTED_PORTFOLIO_DETAIL',
  PORTFOLIO_FEE_CONFIGS = 'PORTFOLIO_FEE_CONFIGS',
  TRANSACTIONS = 'TRANSACTIONS',
  TRANSACTIONS_SEARCH = 'TRANSACTIONS_SEARCH',
  MODEL_PORTFOLIO = 'MODEL_PORTFOLIO',
  MODEL_PORTFOLIO_BY_RISK_SCORE = 'MODEL_PORTFOLIO_BY_RISK_SCORE',
  PORTFOLIO_INSTRUMENT_RATIOS = 'PORTFOLIO_INSTRUMENT_RATIOS',
  INVESTMENT_INSTRUMENT_REMOVALS = 'INVESTMENT_INSTRUMENT_REMOVALS',
  PORTFOLIO_HISTORY_CHART = 'PORTFOLIO_HISTORY_CHART',
  PORTFOLIO_FUTURE_DEVELOPMENT_CHART = 'PORTFOLIO_FUTURE_DEVELOPMENT_CHART',
  MAX_IMAGE_SIZE = 'MAX_IMAGE_SIZE',
  USER_PROFILE_PHOTO = 'USER_PROFILE_PHOTO',
  UPDATE_PROFILE_PHOTO = 'UPDATE_USER_PROFILE_PHOTO',
  BLOG_ARTICLES_PAGE = 'BLOG_ARTICLES_PAGE',
  BLOG_ARTICLE_DETAIL = 'BLOG_ARTICLE_DETAIL',
  BLOG_ARTICLE_PREVIEW = 'BLOG_ARTICLE_PREVIEW',
  COLLABORATOR_INFO = 'COLLABORATOR_INFO',
  COLLABORATOR_PHOTO = 'COLLABORATOR_PHOTO',
  ENTRY_FEE_CALCULATION = 'ENTRY_FEE_CALCULATION',
  UPDATE_PORTFOLIO_PHOTO = 'UPDATE_PORTFOLIO_PHOTO',
  DELETE_INVESTMENT_PHOTO = 'DELETE_INVESTMENT_PHOTO',
  AVAILABLE_INSTRUMENTS = 'AVAILABLE_INSTRUMENTS',
  PUBLIC_INSTRUMENTS = 'PUBLIC_INSTRUMENTS',
  DRAFT_INVESTMENTS_LIST = 'DRAFT_INVESTMENTS_LIST',
  INVESTMENT_CHANGE_DRAFTS_LIST = 'INVESTMENT_CHANGE_DRAFTS_LIST',
  INVESTMENT_CHANGE_DRAFT_DETAIL = 'INVESTMENT_CHANGE_DRAFT_DETAIL',
  THEMATIC_STRATEGIES = 'THEMATIC_STRATEGIES',
  CASH_INSTRUMENTS = 'CASH_INSTRUMENTS',
  STRATEGY_LIMITS = 'STRATEGY_LIMITS',
  STRATEGY_FUTURE_DEVELOPMENT_CHART = 'STRATEGY_FUTURE_DEVELOPMENT_CHART',
  INVESTMENT_PROFILE = 'INVESTMENT_PROFILE',
  MODEL_STRATEGY = 'MODEL_STRATEGY',
  BACKCASTING_CHART = 'BACKCASTING_CHART',
  INSTRUMENT_CHART = 'INSTRUMENT_CHART',
  DEPOSIT_INFO = 'DEPOSIT_INFO',
  BANK_ACCOUNTS = 'BANK_ACCOUNTS',
  DASHBOARD_CHART = 'DASHBOARD_CHART',
  WITHDRAWAL = 'WITHDRAWAL',
  WITHDRAWAL_PORTFOLIOS_LIST = 'WITHDRAWAL_PORTFOLIOS_LIST',
  NOTIFICATION_PROCESSED_SUM = 'NOTIFICATION_PROCESSED_SUM',
  NOTIFICATION_LIST = 'NOTIFICATION_LIST',
  CLIENT_ADDITIONS = 'CLIENT_ADDITIONS',
}
